module.exports = "/images/white-folder.svg?6442877393ecb6e8fd724656d25c85db";